import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-序号",
  "use": "icon-序号-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-序号\"><path d=\"M1024 924.8c-19.2 3.2-38.4 3.2-57.6 3.2-67.2 0-131.2-12.8-188.8-38.4-83.2 64-185.6 102.4-297.6 102.4-262.4 0-480-214.4-480-480S217.6 32 483.2 32s483.2 214.4 483.2 480c0 76.8-19.2 147.2-51.2 211.2 22.4 76.8 57.6 144 108.8 201.6z\" fill=\"#53A0E7\" p-id=\"15737\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol